import React, { useEffect } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { Add, Assignment, Delete, Visibility } from '@material-ui/icons';
import { ConstantPermissions } from 'contexts/useConstant';
import ReactTable from 'components/ReactTable/ReactTable';
import { wsFindBy, wsRemove } from 'services/WService';
import Button from 'components/CustomButtons/Button';
import { useNavigate, Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Toasty, useToasty } from 'hooks/Toasty';
import { makeStyles } from '@material-ui/core';
import { WithApp } from 'contexts/appContext';
import Badge from 'components/Badge/Badge';
import { nDecimal } from 'hooks/Pipe';
import { useState } from 'react';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const useStyles = makeStyles(() => ({
  ...styles,
}));

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Fecha Operación', accessor: 'TaxDate', width: 160, },
  { Header: 'Zona', accessor: 'base_zone_description', width: 90 },
  { Header: 'Cuenta', accessor: 'account', width: 170 },
  { Header: 'Descripción operación', accessor: 'description_operation', width: 230 },
  { Header: 'Monto', accessor: 'amount', width: 150 },
  { Header: 'Operación', accessor: 'operation', width: 120 },
  { Header: 'Referencia', accessor: 'ref2' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function StatementBankList(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [deposits, setDeposits] = useState([]);
  const [notify, showNotify] = useToasty();

  const [filter, setFilter] = useState({});
  const [alert, setAlert] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  async function listDocOperation() {
    setDataLoading(true);
    let res = await wsFindBy('pymt/deposit/index-operation', filter);
    setDataLoading(false);
    if (res.success) {
      setDeposits(res.data);
    }
  }

  useEffect(() => {
    if (Object.keys(filter).length === 0) {
      return;
    }
    listDocOperation();
  }, [filter]);

  return (
    <CardContainer
      // title="Listado de depositos"
      title={(<>Listado de extractos bancarios {dataLoading && <LoadingSpinner />}</>)}
      color="primary"
      icon={<Assignment />}
    >
      <Toasty action={notify} />
      {alert}
      <FilterCustom dateRange diffRange={7} getFilter={setFilter} zone />
      <ReactTable
        defaultWidth={1900}
        columns={columns}
        formatDate="DD-MM-YYYY"
        data={deposits.map((item, i) => {
          return {
            ...item,
            num: (
              <div className="actions-right">
                {i + 1}
              </div>
            ),
            TaxDate: item.TaxDate,
            base_zone_description: item.zone?.description,
            account: item.account,
            description_operation: item.description_operation,
            amount: item.amount,
            operation: item.operation,
            ref2: item.ref2,
          };
        })}
      />
    </CardContainer>
  );
}

export default WithApp(StatementBankList);
